var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f;
import { makeAutoObservable } from "mobx";
import { perRestaurant } from "../di";
import { NotAvailableFulfillmentMethodLabel } from "./NotAvailableFulfillmentMethodLabel";
import { NotAvailableNowLabel } from "./NotAvailableNowLabel";
import { OrderForLabel } from "./OrderForLabel";
import { TemporarilyUnavailableLabel } from "./TemporarilyUnavailableLabel";
import { ProductInstanceAvailabilityService, ProductInstancePreorderSettingsService, } from "../ordering";
let LabelsService = class LabelsService {
    constructor(productInstanceAvailabilityService, productInstancePreorderSettingsService, notAvailableFulfillmentMethodLabel, notAvailableNowLabel, orderForLabel, temporarilyUnavailableLabel) {
        this.productInstanceAvailabilityService = productInstanceAvailabilityService;
        this.productInstancePreorderSettingsService = productInstancePreorderSettingsService;
        this.notAvailableFulfillmentMethodLabel = notAvailableFulfillmentMethodLabel;
        this.notAvailableNowLabel = notAvailableNowLabel;
        this.orderForLabel = orderForLabel;
        this.temporarilyUnavailableLabel = temporarilyUnavailableLabel;
        makeAutoObservable(this);
    }
    compute(view, productInstance) {
        const { unavailabilityReasons, causingParameters } = this.productInstanceAvailabilityService.availability(productInstance);
        const preorderSettings = this.productInstancePreorderSettingsService.preorderSettings(productInstance);
        const result = [
            this.notAvailableFulfillmentMethodLabel.label(view, causingParameters),
            this.notAvailableNowLabel.label(view, unavailabilityReasons, preorderSettings),
            this.orderForLabel.label(unavailabilityReasons, preorderSettings),
            this.temporarilyUnavailableLabel.label(view, unavailabilityReasons),
        ];
        return result.filter((l) => l !== null);
    }
    productCardLabels(productInstance) {
        return this.compute("ProductCard", productInstance);
    }
    orderLineLabels(productInstance) {
        return this.compute("Cart", productInstance);
    }
    menuLabels(variants) {
        if (variants.length === 0)
            return [];
        const labelSets = variants.map((instance) => this.compute("Menu", instance));
        // Show label only if it applies to ALL variants (intersection by message)
        return labelSets[0].filter((label) => labelSets.every((labels) => labels.some((l) => l.message === label.message)));
    }
};
LabelsService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof ProductInstanceAvailabilityService !== "undefined" && ProductInstanceAvailabilityService) === "function" ? _a : Object, typeof (_b = typeof ProductInstancePreorderSettingsService !== "undefined" && ProductInstancePreorderSettingsService) === "function" ? _b : Object, typeof (_c = typeof NotAvailableFulfillmentMethodLabel !== "undefined" && NotAvailableFulfillmentMethodLabel) === "function" ? _c : Object, typeof (_d = typeof NotAvailableNowLabel !== "undefined" && NotAvailableNowLabel) === "function" ? _d : Object, typeof (_e = typeof OrderForLabel !== "undefined" && OrderForLabel) === "function" ? _e : Object, typeof (_f = typeof TemporarilyUnavailableLabel !== "undefined" && TemporarilyUnavailableLabel) === "function" ? _f : Object])
], LabelsService);
export { LabelsService };
